import React from 'react';
import './TestReports.css';
import iconBloodd from '../../../../assets/icons/icon-bloodd.png';
import frame7 from '../../../../assets/icons/Frame7.png';
import frame8 from '../../../../assets/icons/Frame8.png';
import frame9 from '../../../../assets/icons/Frame9.png';

const TestReports = ({ testData }) => {
  return (
    <div className="test-reports">
      <h3 className="test-reports__title">Test Reports</h3>

      <div className="test-reports__item">
        <div className="test-reports__left">
          <img src={iconBloodd} alt="Blood test icon" className="test-reports__icon" />
          <h4 className="test-reports__name">{testData?.testName || 'Blood Test Results'}</h4>
        </div>
        <div className="test-reports__right">
          <p className="test-reports__date">{testData?.date || '20 August 2025'}</p>
          <span className="test-reports__file-size">
            <span className="test-reports__file-size-label">File size :</span>
            <span className="test-reports__file-size-value">{testData?.fileSize || '4 MB'}</span>
          </span>
          <div className="test-reports__actions">
            <img src={frame7} alt="Action 1" className="test-reports__action-icon" />
            <img src={frame8} alt="Action 2" className="test-reports__action-icon" />
            <img src={frame9} alt="Action 3" className="test-reports__action-icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestReports;
